/**
 * @desc 登录
 * @created: 2020/3/25
 * @author: lijun
 * @version : v1.0
 */

import request from '@/plugins/http'
import qs, { stringify } from 'qs'

// 测试服密码登录
export const login = data => {
  return request.post('/login', qs.stringify(data))
}

// 发送短信验证
export const sendVerificationCode = params => {
  return request.get('/sendVerificationCode', params)
}


// 发送短信验证 post
export const sendSmsCode = data => {
  return request.post('/sms/sendSmsCode', data, { json: true })
}



// 正式服短信验证登录
export const formalLogin = data => {
  return request.post('/formalLogin', data, { json: true })
}

export const logout = params => {
  return request.post('/logout', params)
}

// 获取左侧菜单列表
export const getMenuList = params => {
  return request.post('/menu', params);
}

// 修改密码
export const updatePwd = data => {
  return request.post('/user/pwd', qs.stringify(data));
}